const topSlider = () => {
  //@ts-ignore
  new Splide('.top__works-slider-js', {
    type: 'loop',
    perPage: 3,
    arrows: false,
    pagination: false,
    drag: 'free',
    autoScroll: {
      speed: 1,
      pauseOnHover: true,
    },
    breakpoints: {
      1280: {
        perPage: 2,
      },
      992: {
        perPage: 1,
      },
    },
  //@ts-ignore
  }).mount(window.splide.Extensions);
};

export default topSlider;
